<template>
  <v-layout wrap>
    <v-flex
      v-for="(result, index) in searchObject.data"
      :key="index"
      xs12="!isHideMap()"
      :xl6="!isHideMap()"
      :sm6="isHideMap()"
      :md4="isHideMap()"
      :lg3="isHideMap()"
      class="results-layout-card"
      @mouseenter="cardHovered($event, index)"
      @mouseleave="cardLeft"
    >
      <card-home
        :property-info="result"
        :index="index"
        :home-type="'search'"
        :assign-to-client="assignToClient"
        :is-tour-requested="isTourRequested(result)"
        :class="{
          'selected-card':
            searchObject.markedId && searchObject.markedId === result._id
        }"
        @card-view-detail="$emit('open-display-property', result)"
        @card-assign-to="
          isAllocated(assignToClient, result)
            ? null
            : assignProperty(result, assignToClient)"
        @card-new-assign="setAssignModal(true, result)"
        @card-new-request-tour="setAgentRequest(result)"
        @card-set-favorite="setFavorite(result)"
        @card-un-set-favorite="unSetFavorite(result)"
        @card-request-tour="requestTour(result)"
      >
        <template v-slot:hoverCard>
          <!-- THIS SHOWS ON AGENT SEARCH -->
          <v-flex v-if="profileStatus === 'agent'" xs10>
            <div
              class="result-overlay-link"
              @click.stop="$emit('open-display-property', result)"
            >
              <v-icon color="white" class="result-overlay-icon">
                fas fa-search
              </v-icon>
              <div
                v-if="isAssignProgress && assignToClient && assignToClient.name"
              >
                <v-progress-linear
                  :indeterminate="true"
                  color="white"
                  height="2"
                />
              </div>
              <div v-else>
                View Details
              </div>
            </div>
            <template v-if="canRequest(result)">
              <template v-if="assignToClient && assignToClient.name">
                <div
                  class="result-overlay-link"
                  :class="{
                    'assigned-to-client': assignToClientAllocation(result)
                  }"
                  @click.stop="
                    assignToClientAllocation(result)
                      ? null
                      : assignPropertyToClient(result, assignToClient)"
                >
                  <v-icon color="white" class="result-overlay-icon">
                    fas fa-id-badge
                  </v-icon>
                  <div v-if="assignToClientAllocation(result)">
                    Assigned To
                    <span>{{ assignToClient.name }}</span>
                  </div>
                  <template v-else>
                    <div v-if="isAssignProgress">
                      <v-progress-linear
                        :indeterminate="true"
                        color="white"
                        height="2"
                      />
                    </div>
                    <div v-else>
                      Assign To
                      <span>{{ assignToClient.name }}</span>
                    </div>
                  </template>
                </div>
                <div
                  v-if="result.Status.toLowerCase() !== 'sold'"
                  class="result-overlay-link"
                  :class="{ 'requested-for-client': isAssignRequested(result) }"
                  @click.stop="
                    isAssignRequested(result)
                      ? null
                      : requestTourForClient(result, assignToClient)"
                >
                  <v-icon color="white" class="result-overlay-icon">
                    fas fa-paper-plane
                  </v-icon>
                  <div v-if="isAssignProgress">
                    <v-progress-linear
                      :indeterminate="true"
                      color="white"
                      height="2"
                    />
                  </div>
                  <div v-else>
                    {{
                      isAssignRequested(result)
                        ? `Requested for ${assignToClient.name}`
                        : "Request Tour"
                    }}
                  </div>
                </div>
              </template>
              <template
                v-else-if="result && result.Status.toLowerCase() !== 'sold'"
              >
                <div
                  class="result-overlay-link"
                  @click.stop="setAssignModal(true, result)"
                >
                  <v-icon color="white" class="result-overlay-icon">
                    fas fa-id-badge
                  </v-icon>
                  <div>Assign To</div>
                </div>
                <div
                  v-if="result.Status.toLowerCase() !== 'sold'"
                  class="result-overlay-link"
                  @click.stop="setAgentRequest(result)"
                >
                  <v-icon color="white" class="result-overlay-icon">
                    fas fa-paper-plane
                  </v-icon>
                  <div>Request Tour</div>
                </div>
              </template>
            </template>
          </v-flex>
          <!-- THIS SHOWS ON CLIENT SEARCH -->
          <v-flex v-else-if="profileStatus === 'client'" xs10>
            <div
              class="result-overlay-link"
              @click.stop="$emit('open-display-property', result)"
            >
              <v-icon color="white" class="result-overlay-icon">
                fas fa-search
              </v-icon>
              <div v-if="clientProgress">
                <v-progress-linear
                  :indeterminate="true"
                  color="white"
                  height="2"
                />
              </div>
              <div v-else>
                View Details
              </div>
            </div>
            <div
              class="result-overlay-link"
              :class="{ 'standard-text': isFavorite(result) }"
              @click.stop="
                isFavorite(result) ? unSetFavorite(result) : setFavorite(result)"
            >
              <v-icon
                :color="isFavorite(result) ? 'red' : 'white'"
                class="result-overlay-icon"
              >
                fas fa-heart
              </v-icon>
              <div v-if="clientProgress">
                <v-progress-linear
                  :indeterminate="true"
                  color="white"
                  height="2"
                />
              </div>
              <div v-else>
                Save
              </div>
            </div>
            <div
              v-if="isFavorite(result)"
              class="result-overlay-link"
              :class="{ 'standard-text': isTourRequested(result) }"
              @click.stop="isTourRequested(result) ? null : requestTour(result)"
            >
              <v-icon
                :color="isTourRequested(result) ? 'green' : 'white'"
                class="result-overlay-icon"
              >
                fas fa-paper-plane
              </v-icon>
              <div v-if="clientProgress">
                <v-progress-linear
                  :indeterminate="true"
                  color="white"
                  height="2"
                />
              </div>
              <div v-else>
                {{
                  isTourRequested(result) ? "Tour Requested" : "Request Tour"
                }}
              </div>
            </div>
          </v-flex>
        </template>
      </card-home>
    </v-flex>
    <client-list-menu
      v-if="profileStatus === 'agent'"
      :show-modal="displayAssignModal"
      :selected-property="selectedProperty"
      :associated-clients="associatedClients"
      :set-request="clientRequestTour"
      @assign-client-to-property="assignProperty(selectedProperty, $event)"
      @close-modal="closeAssignModal()"
    />
  </v-layout>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import ClientListMenu from './ClientListMenu.vue'
import CardHome from '../uiUtils/CardHome.vue'
import refreshContent from '../mixins/refreshContent'
import {
  getFavoriteObjectFromPropertyId,
  getClientFavFromPropertyId
} from '../../utils/propertyUtils'
import { sortNames } from '../../utils/generalUtils'
import { activeRouteHomeIds } from '../../services/routeService'
import {
  removeFromClientFavorite,
  requestPropertyTour,
  setPropertyasClientFavorite
} from '../../services/propertiesService'
import { HIDE_STATUSES } from '../common/searchPropertyConst'

export default {
  components: { ClientListMenu, CardHome },

  filters: {
    commaSeparated(val) {
      return (val || '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    kNumber(val) {
      return (val / 1000).toString() + 'K'
    }
  },

  mixins: [refreshContent],

  props: {
    searchObject: {
      type: Object,
      required: true
    },
    assignToClient: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      resultImageHoverOptions: [
        {
          icon: 'image',
          title: 'Request Showing'
        },
        {
          icon: 'heart',
          title: 'Save'
        }
      ],
      displayPropertyModal: false,
      displayAssignModal: false,
      selectedProperty: null,
      clientRequestTour: false,
      showProgress: true,
      clientProgress: false
    }
  },

  computed: {
    ...mapState('common', ['profileStatus']),
    ...mapState('agent', ['hideMap']),
    ...mapState('client', ['clientData', 'clientFavorites']),

    associatedClients() {
      if (this.agentData) {
        return sortNames(this.agentData.clients)
      }
      return []
    }
  },

  methods: {
    ...mapActions('client', ['updateClientPropertiesAction']),
    ...mapMutations('common', {
      setMarkedMarker: 'SET_MARKED_MARKER'
    }),

    isHideMap() {
      return this.hideMap || !this.searchObject.searchResult
    },

    cardHovered(event, propertyIndex) {
      if (propertyIndex >= 0) {
        this.setMarkedMarker(propertyIndex)
      }
    },

    cardLeft() {
      this.setMarkedMarker(-1)
    },

    setModalOpened(status) {
      this.displayPropertyModal = status
    },

    setAgentRequest(result) {
      this.clientRequestTour = true
      this.setAssignModal(true, result)
    },

    setAssignModal(status, value = null) {
      this.displayAssignModal = status
      this.selectedProperty = value
    },

    closeAssignModal() {
      this.clientRequestTour = false
      this.displayAssignModal = false
    },

    // Check if property is already requested for a client
    // in case of home search redirection to search page
    assignToClientAllocation(property) {
      return this.assignToClient.homes.some(
        home => home.propertyId === property._id
      )
    },

    isAssignRequested(property) {
      const homeObject = getFavoriteObjectFromPropertyId(
        this.assignToClient.homes,
        property._id
      )
      return homeObject && homeObject.requestTour === true
    },

    assignProperty(propertyObject, selectedClient) {
      this.setAssignModal(false)
      if (this.clientRequestTour) {
        this.requestTourForClient(propertyObject, selectedClient)
      } else {
        this.assignPropertyToClient(propertyObject, selectedClient)
      }
    },

    isAllocated(clientObject, property) {
      const isClientAssigned = clientObject.homes.some(
        home => home.propertyId === property._id
      )
      return isClientAssigned
    },

    // Check if a property can be requested (allow active properties)
    canRequest(fav) {
      return !HIDE_STATUSES.includes(fav.Status)
    },

    // Check if a property is part of client favorite list
    isFavorite(property) {
      if (this.clientFavorites) {
        return this.clientFavorites.some(home => home._id === property._id)
      }
      return false
    },

    // Check if the property is already requested or a part of active route
    isTourRequested(property) {
      let clientFav = { ...property }
      if (!property.favoriteId) {
        clientFav = getClientFavFromPropertyId(
          this.clientFavorites,
          property._id
        )
      }
      return clientFav
        ? clientFav.requestTour ||
            activeRouteHomeIds(this.clientData).includes(clientFav._id)
        : false
    },

    // Sets a property as client favorite
    async setFavorite(property) {
      this.clientProgress = true
      const updatedClientProperties = await setPropertyasClientFavorite(
        this.clientData,
        this.clientFavorites,
        property
      )
      if (updatedClientProperties) {
        this.updateClientPropertiesAction(updatedClientProperties)
      }
      this.clientProgress = false
    },

    // Remove property from favorite in client search page
    async unSetFavorite(property) {
      this.clientProgress = true
      const propertyObject = getClientFavFromPropertyId(
        this.clientFavorites,
        property._id
      )
      if (!this.isTourRequested(propertyObject)) {
        const updatedClientProperties = await removeFromClientFavorite(
          this.clientData,
          this.clientFavorites,
          propertyObject
        )

        if (updatedClientProperties) {
          this.updateClientPropertiesAction(updatedClientProperties)
        }
      }
      this.clientProgress = false
    },

    // Request tour for a property in client search page
    async requestTour(property) {
      this.clientProgress = true
      const propertyObject = getClientFavFromPropertyId(
        this.clientFavorites,
        property._id
      )
      const updatedClientProperties = await requestPropertyTour(
        this.clientData,
        this.clientFavorites,
        propertyObject
      )

      if (updatedClientProperties) {
        this.updateClientPropertiesAction(updatedClientProperties)
      }
      this.clientProgress = false
    }
  }
}
</script>

<style lang="sass">
.standard-text, .standard-text i
  cursor: default !important
  @extend %disable-selection
</style>

<style lang="sass" scoped>
@media only screen and (max-width: 600px)
 .container
  padding: 0px 10px !important

.results-layout-card
  padding: 0 8px !important
  margin-top: 1.4rem
  @media only screen and (min-width: 600px)
    margin-top: 0
    margin-bottom: 1.5rem

.selected-card
  border: 0.4rem solid $hwayzYellow !important

.result-overlay-link
  @extend %card__hover-link
  display: flex
  i
    flex: 1
  div
    flex: 5
  span
    text-transform: capitalize
  &.assigned-to-client, &.requested-for-client
    cursor: default
    div
      color: $hwayzYellow
  &.requested-for-client div
    color: $hwayzGreen

.result-overlay-icon
  @extend %card__hover-icon

.container.grid-list-sm .layout:only-child
  margin: 0px

@media only screen and (max-width: 960px)
  .result-overlay-link
    font-size: 1.7rem

  .result-overlay-icon
    font-size: 2rem
</style>
